import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Row, Col, Card, Form, message, Button, Input, Divider } from 'antd';
import axios from "./../services/http";

const PaymentAuth = () => {


    const { paymentAuth, status, authLevel } = useParams();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [authorizing, setAuthorizing] = useState(false);
    const alreadyCalled = useRef(false);

    useEffect(() => {

        if (alreadyCalled.current) return;
        alreadyCalled.current = true;

        if (status === "0") handleSubmit({ partidas: null });
        if (status === "1" && authLevel === "autorizado_n2") handleSubmit({ partidas: null });
    },[]);

    const handleSubmit = async (values) => {
        try {
            setAuthorizing(true);
            const { partidas } = values;

            const response = await axios.HTTP_POST("/api/v1/payments/authorize", { paymentAuth, status, authLevel, partidas });
            console.log('response', response);
            if (response && response.data) {
                setAuthorizing(false);
                Navigate("/home");
            }
        } catch (e) {
            console.error('Error al autorizar:', e);
            message.error('Hubo un error al autorizar el control de pago');
        }
    }

    const Navigate = (path) => {
        navigate(path);
    }

    return (
        <>
            <div 
            className='container-content'
            >
                <Row gutter={[8, 8]} justify="center">
                    {/* { authorizing ? <h1>Autorizando Control de Pago....</h1> : <h1> Fue autorizado satisfactoriamente </h1>} */}
                    {authLevel === "autorizado_n1" && status === "1"
                        ?
                        <Col xs={{ flex: '100%' }} md={{ flex: '60%' }} xl={{ flex: '40%' }}>
                            <Card>
                                <Form
                                layout="vertical"
                                    form={form}
                                    onFinish={handleSubmit}
                                >
                                    <Form.Item
                                        label="Partidas"
                                        name="partidas"
                                        rules={[{ required: true, message: 'Por favor ingrese las partidas' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Divider style={{ margin: '24px 0' }} />
                                    <Form.Item>
                                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                                            <Button type="primary" loading={authorizing} htmlType="submit">
                                                Autorizar
                                            </Button>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </Card>
                        </Col>
                    :null}
                </Row>
            </div>
        </>
    )
} 

export default PaymentAuth;